<template>
    <div>
      <!-- Application Header -->
      <header class="c-main-header-nav">
        <div class="c-responsive-container">
          <div class="c-as-block">
            <div class="c-header-btn-holder">
              <!-- Button when menu is available -->
              <button class="c-burger-button" v-on:click="toggleOffcanvas()"><i class="fa fa-bars" aria-hidden="true"></i></button>
              <!-- Button when menu is NOT available -->
              <!-- <button class="c-burger-button" v-on:click="actionDiscardChanges()" v-else><i class="fa fa-times" aria-hidden="true"></i></button> -->
            </div>
            <!-- Header Title -->
            <div class="c-has-view-title"><b>{{currentViewName}}</b></div>
          </div>
        </div>
      </header>
      <!-- Application Body content -->
      <main class="c-main-body-wrap">
        <div class="c-responsive-container c-relative c-p-top-10">
          <!-- #region CONTENT HERE -->          
          <!-- Single Event to show -->
          <ul class="c-items-list" v-if="mainListOfItemsForView">
            <li class="c-items-for-future-events" v-for="logItem in mainListOfItemsForView">
              <div class="c-fs-12">27.11.2017. - 20:45:30 h - Mladen Mitrovic</div>
              <div class="c-fs-12">Nemanja Radonjic & La Bend - 29.11.2017</div>
              <div class="c-fs-12">Pre: B6 - Suzana Cavic - Cavicka</div>
              <div class="c-fs-12">Posle: B6 - Dragan Todorovic</div>
            </li>
          </ul>
          <!-- No content message -->
          <emo-well-comp 
            v-else
            input-well-type="no-content" 
            input-txt-msg="Trenutno nema zakazanih događaja"
          ></emo-well-comp>          
          <!-- #endregion CONTENT HERE -->
        </div>
      </main>
      <!-- Application Footer Menu -->
      <footer class="c-main-footer-nav">
        <div class="c-responsive-container c-relative">
          <!-- Add New content floating button -->
          <button class="c-btn c-floating-circle" v-on:click="addNewContent()"><i class="fa fa-plus" aria-hidden="true"></i></button>
          <!-- Footer Nav List (list with navigation buttons) -->
          <footer-nav-list></footer-nav-list>
        </div>
      </footer>
    </div>
</template>

<script>
import router from '@/router/index'
import EventBus from '@/EventBus'
import FooterNavList from '@/components/footer/FooterNavList'
import EmoWellComp from '@/components/wells/EmoWellComp'

export default {
  name: 'LogsHistory',
  props: [],
  components: {
    FooterNavList: FooterNavList,
    EmoWellComp: EmoWellComp
  },  
  data () {
    return {
      // ~ name of current view (component title)
      currentViewName: null,
      // ~ each time we have loading process this array will have length > 0
      isLoading: [],
      // ~ main variable to hold all event items that we want to show on view
      mainListOfItemsForView: null
    }
  },
  methods: {
    // ~ hide offcanvas component inside 'MainApp' component
    toggleOffcanvas: function (){
      EventBus.$emit('toggleOffcanvas');
    },
    // ~ call api to get list of all Future Events
    // getAllLogs: function () {
    //   // ToDo - Create API CALLS
    //   if (DummyData.futureEvents.table){
    //     this.mainListOfItemsForView = DummyData.futureEvents.table;
    //   }      
    // }
  },
  created () {
    //console.log('~ created- LogsHistory component!');
    // ~ once we created this view, we must call api to get list of all Future Events
    //this.getAllLogs();
    // ~ call action when router is ready
    this.$router.onReady(function () {
      if (this.$route.meta) {
        this.currentViewName = this.$route.meta.headerTitle
      }
    }.bind(this));
  },
  mounted () {
    //console.log('~ mounted - LogsHistory component!');
  },
  destroyed () {
    //console.log('~ destroyed- LogsHistory component!');
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style></style>



// WEBPACK FOOTER //
// src/components/logs/LogsHistory.vue